<template>
  <v-dialog
    v-model="dialog"
    max-width="750px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="my-0"
        text
        icon
        color="primary"
        v-on="on"
      >
        <v-icon medium>
          add
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="green"
      title="Employee Skills"
      text="Appraise employee skills"
      class="mb-0"
    >
      <form v-if="!loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="mb-0 pb-0"
            >              
              <v-autocomplete
                v-model="selectedSkill"          
                v-validate="'required'"
                :items="validSkills"          
                :error-messages="errors.collect('skill')"
                data-vv-name="skill"
                label="Skill"
                placeholder="Skill Assignment"
                item-text="name"
                item-value="id"
                hide-no-data
                hide-selected
                @change="resetLevels"
              >
                <template v-slot:selection="data">
                  <v-chip :input-value="data.selected">
                    <v-avatar
                      tile
                      left
                    >
                      <img :src="data.item.image_url">
                    </v-avatar>
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-avatar tile>
                      <img :src="data.item.image_url">
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name" />
                      <v-list-item-subtitle v-html="data.item.category.name" />
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col
              class="my-0 py-0"
              cols="12"
            >  
              <v-rating
                v-model="rating"
                :length="skillLevels.length"
              >
                <template v-slot:item="props">
                  <v-icon
                    :color="props.isFilled ? genColor(props.index) : 'grey lighten-1'"
                    large
                    @click="props.click"
                  >
                    {{ props.isFilled ? 'mdi-star-circle' : 'mdi-star' }}
                  </v-icon>
                </template>
              </v-rating>
              <v-data-table
                v-show="skillLevels.length > 0"
                :headers="headers"
                :items="skillLevels"
                :sort-by.sync="sortBy"
                hide-default-footer
                class="elevation-1"
              >
                <template v-slot:item="props">
                  <tr 
                    :class="{active: props.item.level === rating}"
                  >
                    <td class="text-right">
                      {{ props.item.level }}
                    </td>
                    <td class="text-justify">
                      {{ props.item.description }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Appraise
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },    
    },
    data () {
      return {
        sortBy: 'level',
        headers: [
          {
            text: 'Level',
            value: 'level',
            sortable: false, 
          },
          { 
            text: 'Description', 
            align: 'left', 
            value: 'description',
            sortable: false, 
          },
        ],
        colors: ['error', 'warning', 'indigo', 'success', 'primary'],
        rating: 1,
        loading: false,
        progressing: false,
        dialog: null,
        skills: [],
        employeeSkills: [],
        selectedSkill: null,
        selectedLevel: null,
      }
    },
    computed: {
      validSkills () {
        return this.skills.filter(skill => {
          return skill.levels.length > 0 && this.employeeSkills.find(employeeSkill => employeeSkill.skill_id === skill.id) === undefined
        })
      },
      skillLevels () {
        return (this.skills.find(skill => {
          return skill.id === this.selectedSkill
        }) || {}).levels || []
      },
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.resetForm()

          this.loadData()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.employeeSkills().create(this.employeeUid, this.prepareFormData()) 
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$snack({ message: 'Employee skill added' })
                  this.$emit('added')
                
                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      loadData () {     
        let requests = [
          this.$api.employeeSkills().list(this.employeeUid),
        ]

        if (this.skills.length <= 0) requests.push(this.$api.skills().list(['levels']))

        this.loading = true

        Promise.all(requests)
          .then(([employeeSkills, skills]) => {
            if (skills) this.skills = skills.data

            this.employeeSkills = employeeSkills.data
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },
      prepareFormData () {
        this.selectedLevel = this.skillLevels[this.rating - 1]

        return {
          skill_level_id: this.selectedLevel.id,
        }
      },
      genColor (i) {
        return this.colors[i]
      },
      resetLevels () {
        this.selectedLevel = null
        this.rating = 1
      },
      resetForm () {
        this.selectedSkill = null
        this.selectedLevel = null
        
        this.$validator.reset()
      },
    },
  }
</script>
